export const StatusTypes = {
  IDLE: "idle",
  ACTIVE: "active",
  DRAGGED: "dragged",
  POSITIONED: "positioned"
};
